import { CommonSystemError } from "../error";
export class PromiseUtils {
    static async allSettledWithThrow(values) {
        const results = await Promise.allSettled(values);
        return results.map((result) => {
            if (result.status === "rejected") {
                if (result.reason instanceof Error) {
                    throw result.reason;
                }
                throw new CommonSystemError.Unexpected("failed to exec.", result.reason);
            }
            return result.value;
        });
    }
}
//# sourceMappingURL=promise-utils.js.map